import React from "react";

function WorkflowSection() {
  return (
    <section className="section workflow-section" id="workflow">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-subtitle">Our Process</span>
          <h2>How We Work With You</h2>
          <p className="section-description">
            A proven methodology for successful streaming platform implementation
          </p>
        </div>

        <div className="timeline">
          {/* Step 1 */}
          <div className="timeline-item" data-aos="fade-right">
            <div className="timeline-content">
              <div className="timeline-number">01</div>
              <h3>Discovery &amp; Architecture</h3>
              <p>
                We assess your current data landscape, identify key use cases,
                and design a tailored architecture that aligns with your business
                objectives.
              </p>
              <ul className="timeline-features">
                <li>Current state assessment</li>
                <li>Use case prioritization</li>
                <li>High-level architecture design</li>
                <li>ROI analysis</li>
              </ul>
            </div>
          </div>

          {/* Step 2 */}
          <div className="timeline-item" data-aos="fade-left">
            <div className="timeline-content">
              <div className="timeline-number">02</div>
              <h3>Proof of Concept</h3>
              <p>
                We build a working prototype to validate the architecture and
                demonstrate business value with real data.
              </p>
              <ul className="timeline-features">
                <li>Rapid prototyping</li>
                <li>Data pipeline setup</li>
                <li>Initial integration</li>
                <li>Value demonstration</li>
              </ul>
            </div>
          </div>

          {/* Step 3 */}
          <div className="timeline-item" data-aos="fade-right">
            <div className="timeline-content">
              <div className="timeline-number">03</div>
              <h3>Pilot Implementation</h3>
              <p>
                We implement the solution in a controlled environment with a
                focused use case to validate performance and business impact.
              </p>
              <ul className="timeline-features">
                <li>End-to-end implementation</li>
                <li>Performance testing</li>
                <li>User training</li>
                <li>Success metrics validation</li>
              </ul>
            </div>
          </div>

          {/* Step 4 */}
          <div className="timeline-item" data-aos="fade-left">
            <div className="timeline-content">
              <div className="timeline-number">04</div>
              <h3>Enterprise Rollout</h3>
              <p>
                We scale the solution across your organization, integrating with
                all required systems and processes.
              </p>
              <ul className="timeline-features">
                <li>Enterprise deployment</li>
                <li>Integration with existing systems</li>
                <li>Organization-wide training</li>
                <li>Knowledge transfer</li>
              </ul>
            </div>
          </div>

          {/* Step 5 */}
          <div className="timeline-item" data-aos="fade-right">
            <div className="timeline-content">
              <div className="timeline-number">05</div>
              <h3>Managed Services</h3>
              <p>
                We provide ongoing support and optimization to ensure your
                streaming platform continues to deliver value.
              </p>
              <ul className="timeline-features">
                <li>24/7 monitoring</li>
                <li>Performance optimization</li>
                <li>Regular updates &amp; patches</li>
                <li>Continuous improvement</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="workflow-cta" data-aos="fade-up">
          <h3>Ready to start your streaming journey?</h3>
          <p>
            Our team of Confluent experts is ready to guide you through every step
            of the process.
          </p>
          <a href="/contact" className="btn btn-primary" 
            style={{ 
              cursor: 'pointer',
              pointerEvents: 'auto',
            }}
          >
            Schedule a Consultation
          </a>
        </div>
      </div>
    </section>
  );
}

export default WorkflowSection;
